

<p-table 
[columns]="selectedColumns" 
[value]="Dataset" 
[paginator]="Dataset.length > 3 ? true: false"
appendTo="body" 
[totalRecords]="totalRecords"
[rows]="5" 
[pageLinks]="constantService.DEFAULT_PAGELINKS"
#dt>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
        <td [attr.colspan]="columns.length">
            {{tbldatamsg}}
        </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
        @for(col of columns; track col;) {
          <th id="columns" pResizableColumn [pSortableColumn]="col.field" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
        }
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-columns="columns">
      <tr  [ngClass]="(row['rsmsStatus'] | lowercase)== 'e' ? 'ui-widget-error-row' : 'ui-widget-NoUpdated-row'">
        @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
          <td class="ui-resizable-column" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                <div [pTooltip]="row[col.field]" [id]="'row-' + idx + '-' + col.field"></div>
                @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float') {
                       <!-- set Boolean -->
                        @if((col.datatype | lowercase) =='boolean'){
                        <span>
                          {{row[col.field] == 1 ? 'true' : 'false'}}
                        </span>
                        }@else{<span>
                          {{row[col.field]}}
                        </span>
                        }
                }
                @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float') {
                  <span style="float:right;">
                    {{row[col.field]}}
                  </span>
                }
            </td>
        }
      </tr>
  </ng-template>
  <ng-template pTemplate="paginatorright">
      Total Records: {{Dataset.length == 0? 0 : totalRecords}}
     
    </ng-template>
    <ng-template  pTemplate="paginatorleft">
    </ng-template>
</p-table>
